module.exports = __webpack_public_path__ + "media/site_templates/www.rangehood-installation.com.au/images/our_services_2-ce4a7a05c84239a5b3bf6793d661070f.jpg";